class Values extends HTMLElement {

  static observedAttributes = [
    "laterality",
    "measure",
  ]

  attributeChangedCallback(name,oldValue,newValue) {
    if ( (name === "laterality") && (newValue != oldValue) ) {
      if (newValue === "bilateral") {
        this.querySelector("input[name='valueRight']").removeAttribute("required")
      }
      else if (newValue === "unilateral") {
        this.querySelector("input[name='valueRight']").setAttribute("required","")
      }
    }
  }

}

export default Values
